/* Fast Shop — Cabezal de Ducha: JavaScript compartido entre todas las sections "fs-*".
   Cargado una sola vez en layout/theme.liquid (defer). Cada función busca sus propios
   elementos por atributo data-fs-* en todo el documento, ya que ahora el contenido vive
   repartido en varias sections independientes en vez de un único contenedor. */

(function () {
  if (window.__fsChuveiroInit) return;
  window.__fsChuveiroInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    inicializarCuentaAtras();
    inicializarGaleria();
    inicializarSelectorOferta();
    inicializarInterruptores();
    inicializarAcordeones();
    inicializarCarruselTestimonios();
    inicializarCarruselFotos();
    inicializarBarraFija();
    inicializarVolverArriba();
    inicializarMostrarMasResenas();
  });

  function inicializarCuentaAtras() {
    var cajas = document.querySelectorAll('[data-fs-cuenta-atras]');
    if (!cajas.length) return;
    var total = 4 * 3600 + 19 * 60 + 16;
    function pintar() {
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      cajas.forEach(function (caja) {
        caja.querySelector('[data-fs-horas]').textContent = String(h).padStart(2, '0');
        caja.querySelector('[data-fs-minutos]').textContent = String(m).padStart(2, '0');
        caja.querySelector('[data-fs-segundos]').textContent = String(s).padStart(2, '0');
      });
    }
    pintar();
    setInterval(function () {
      total = total > 0 ? total - 1 : 4 * 3600 + 19 * 60 + 16;
      pintar();
    }, 1000);
  }

  function inicializarGaleria() {
    var marco = document.querySelector('[data-fs-marco-principal]');
    var miniaturas = document.querySelectorAll('[data-fs-miniatura-galeria]');
    if (!marco || !miniaturas.length) return;
    var img = marco.querySelector('img');
    var video = marco.querySelector('video');

    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        miniaturas.forEach(function (m) { m.classList.remove('fs-activa'); });
        mini.classList.add('fs-activa');
        if (mini.dataset.fsEsVideo) {
          img.style.display = 'none';
          if (video) {
            video.style.display = 'block';
            video.currentTime = 0;
            video.play();
          }
          marco.classList.add('fs-reproduciendo');
        } else {
          if (video) { video.pause(); video.style.display = 'none'; }
          marco.classList.remove('fs-reproduciendo');
          img.style.display = 'block';
          img.src = mini.dataset.fsImagenGrande;
        }
      });
    });
  }

  function inicializarSelectorOferta() {
    var opciones = document.querySelectorAll('[data-fs-opcion-oferta]');
    if (!opciones.length) return;
    opciones.forEach(function (opcion) {
      opcion.addEventListener('click', function () {
        opciones.forEach(function (o) { o.classList.remove('fs-seleccionada'); });
        opcion.classList.add('fs-seleccionada');
        actualizarPrecioTotal();
      });
    });
    actualizarPrecioTotal();
  }

  function actualizarPrecioTotal() {
    var seleccionada = document.querySelector('[data-fs-opcion-oferta].fs-seleccionada');
    if (!seleccionada) return;
    var nuevo = seleccionada.dataset.fsPrecioNuevo;
    var viejo = seleccionada.dataset.fsPrecioViejo;
    var variantId = seleccionada.dataset.fsVariantId;
    document.querySelectorAll('[data-fs-precio-total-valor]').forEach(function (el) {
      el.textContent = nuevo + ' €';
    });
    document.querySelectorAll('[data-fs-precio-total-viejo]').forEach(function (el) {
      el.textContent = viejo ? viejo + ' €' : '';
    });
    var inputVariante = document.querySelector('#fs-input-variant-id');
    if (inputVariante && variantId) inputVariante.value = variantId;
  }

  function inicializarInterruptores() {
    document.querySelectorAll('[data-fs-interruptor]').forEach(function (interruptor) {
      interruptor.addEventListener('click', function () {
        interruptor.classList.toggle('fs-activo');
      });
    });
  }

  function inicializarAcordeones() {
    document.querySelectorAll('.fs-item-acordeon').forEach(function (item) {
      var cabecera = item.querySelector('.fs-cabecera-acordeon');
      if (!cabecera) return;
      cabecera.addEventListener('click', function () {
        var yaAbierto = item.classList.contains('fs-abierto');
        var grupo = item.closest('[data-fs-grupo-acordeon]');
        if (grupo) {
          grupo.querySelectorAll('.fs-item-acordeon.fs-abierto').forEach(function (otro) {
            if (otro !== item) otro.classList.remove('fs-abierto');
          });
        }
        item.classList.toggle('fs-abierto', !yaAbierto);
      });
    });
  }

  function inicializarCarruselTestimonios() {
    var tarjetas = document.querySelectorAll('[data-fs-testimonio]');
    var anterior = document.querySelector('[data-fs-testimonio-anterior]');
    var siguiente = document.querySelector('[data-fs-testimonio-siguiente]');
    if (!tarjetas.length) return;
    var indice = 0;
    function mostrar(nuevo) {
      tarjetas[indice].style.display = 'none';
      indice = (nuevo + tarjetas.length) % tarjetas.length;
      tarjetas[indice].style.display = 'block';
    }
    if (anterior) anterior.addEventListener('click', function () { mostrar(indice - 1); });
    if (siguiente) siguiente.addEventListener('click', function () { mostrar(indice + 1); });
  }

  function inicializarCarruselFotos() {
    document.querySelectorAll('[data-fs-carrusel-fotos]').forEach(function (carrusel) {
      var marcos = carrusel.querySelectorAll('.fs-marco-foto');
      var puntos = carrusel.querySelectorAll('[data-fs-puntos-foto] span');
      if (!marcos.length) return;
      var indice = 0;
      function mostrar(nuevo) {
        marcos[indice].classList.remove('fs-activo');
        if (puntos[indice]) puntos[indice].classList.remove('fs-activo');
        indice = (nuevo + marcos.length) % marcos.length;
        marcos[indice].classList.add('fs-activo');
        if (puntos[indice]) puntos[indice].classList.add('fs-activo');
      }
      puntos.forEach(function (punto, i) { punto.addEventListener('click', function () { mostrar(i); }); });
      setInterval(function () { mostrar(indice + 1); }, 4500);
    });
  }

  function inicializarBarraFija() {
    var barra = document.querySelector('[data-fs-barra-fija]');
    var disparador = document.querySelector('[data-fs-disparador-barra-fija]');
    if (!barra || !disparador || !('IntersectionObserver' in window)) return;
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        var yaPaso = !entrada.isIntersecting && entrada.boundingClientRect.top < 0;
        barra.classList.toggle('fs-visible', yaPaso);
      });
    }, { threshold: 0 });
    observador.observe(disparador);
  }

  function inicializarVolverArriba() {
    var boton = document.querySelector('[data-fs-volver-arriba]');
    if (!boton) return;
    window.addEventListener('scroll', function () {
      boton.classList.toggle('fs-visible', window.scrollY > 900);
    });
    boton.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function inicializarMostrarMasResenas() {
    var boton = document.querySelector('[data-fs-mostrar-mas-resenas]');
    if (!boton) return;
    boton.addEventListener('click', function () {
      document.querySelectorAll('.fs-tarjeta-resena.fs-oculta').forEach(function (t) { t.classList.remove('fs-oculta'); });
      boton.style.display = 'none';
    });
  }
})();
